import { default as videojs } from 'video.js';
import { ComponentBaseOptions } from '../models';
import { ComponentBase } from './component-base';

export class OverlayButton extends ComponentBase {

    static readonly ComponentName: string = 'OverlayButton';

    private classList: string;

    private opacityTimer: number;
    private hideTimer: number;
    private focusTimer: number;

    constructor(player: videojs.Player, options?: ComponentBaseOptions) {
        super(player, {...options});
    }

    /**
     * @inheritDoc
     */
    name(): string {
        return OverlayButton.ComponentName;
    }

    createEl(): Element {
        this.classList = (<ComponentBaseOptions>this.options_)?.classList;
        const element: Element = super.createEl('button', {
            className: this.classList,
        });

        element.textContent = (<ComponentBaseOptions>this.options_)?.text;
        return element;
    }

    show(): void {
        if (this.opacityTimer) {
            clearTimeout(this.opacityTimer);
        }
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }
        if (this.focusTimer) {
            clearTimeout(this.focusTimer);
        }

        this.contentEl().className = this.classList;

        setTimeout(() => {
            this.removeClass('hide');
            this.addClass('focus');
            this.focusTimer = <unknown>setTimeout(() => {
                this.removeClass('focus');
                this.focusTimer = null;
            }, 75) as number;
            this.opacityTimer = <unknown>setTimeout(() => {
                this.addClass('no-opacity');
                this.opacityTimer = null;
            }, 225) as number;
            this.hideTimer = <unknown>setTimeout(() => {
                this.addClass('hide');
                this.removeClass('no-opacity');
                this.hideTimer = null;
            }, 400) as number;
        });
    }

}
